import { A as AppDot } from '../../dist/index-0ee62650.esm.js';
export { A as default } from '../../dist/index-0ee62650.esm.js';
import 'react';
import 'react-native';
import '../../dist/useTheme-90e8e2c2.esm.js';
